import find from 'lodash/find';
import size from 'lodash/size';
import head from 'lodash/head';

export class HomeService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.homeResourceUrl = this.apiService.getResourceUrl('home');
		this.contactInfoResourceUrl = this.apiService.getResourceUrl('contact');
		this.donationInfoResourceUrl = this.apiService.getResourceUrl('donation');
		this.socialLinksResourceUrl = this.apiService.getResourceUrl('social-links');
		this.subscribeResourceUrl = this.apiService.getResourceUrl('newsletter/subscribe');
		this.footerLogoResourceUrl = this.apiService.getResourceUrl('rhnscny-logo');

		this.homeResource = this.$resource(this.homeResourceUrl);
		this.contactInfoResource = this.$resource(this.contactInfoResourceUrl);
		this.donationInfoResource = this.$resource(this.donationInfoResourceUrl);
		this.subscribeResource = this.$resource(this.subscribeResourceUrl);
		this.socialLinksResource = this.$resource(this.socialLinksResourceUrl);
		this.footerLogoResource = this.$resource(this.footerLogoResourceUrl);
	}

	getHomeDetails(details) {
		return this._getHomeDetailsObject(details.data);
	}

	/**
	 * function to get contact info details
	 * @return {object} [information related to contact info details]
	 */
	getContactInfoDetails() {
		const promise = this.contactInfoResource.get().$promise;

		return promise.then(details => this._getContactInformationObject(details.data));
	}

	/************
      * To get Donation Url
      ***************/
	getDonationUrl() {
		const promise = this.donationInfoResource.get().$promise;

		return promise
			.then(({ data }) => this._getSubContentDetails(data))
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			})
	}

	/************
      * To get Social links
      ***************/
	getSocialLinks() {
		const promise = this.socialLinksResource.get().$promise;

		return promise
			.then(details => this._getSocialLinks(details.data))
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			})
	}

	getFooterLogo() {
		const promise = this.footerLogoResource.get().$promise;

		return promise
			.then(({ data }) => head(data).details)
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	addSubscriber(emailDetails) {
		const promise = this.subscribeResource.save(emailDetails).$promise;

		return promise
			.then(response => response)
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	//*******************************Private Methods****************************** */

	_getHomeDetailsObject(details) {
		return details.map(data => ({
			moduleName: this._getModuleNameObject(data.module),
			content: this._getContentObject(data.content),
			slug: data.slug || null
		}));
	}

	_getModuleNameObject(value) {
		return {
			displayName: value.display_name,
			name: value.name
		}
	}

	_getContentObject(details) {
		return details.map(value => ({
			id: value.content_id,
			title: value.title,
			name: value.name,
			description: value.description,
			createdAt: value.created_at,
			image: this.apiService.getResourceUrl(`files/images/${value.image}`),
			pdf: value.pdf,
			url: value.url,
			buttonText: value.button_text,
			newsDate: value.news_date,
			slug: value.slug || null,
			ada: value.ada ? this._getAdaDetailsObject(value.ada) : {}
		}));
	}

	_getAdaDetailsObject(value) {
		return {
			bannerImageText: value.banner_image_text
		}
	}

	_getSubContentDetails({ url }) {
		return {
			url
		}
	}

	_getSocialLinks(socialLinks) {
		return socialLinks.map(({ name, url }) => {
			return {
				name,
				url,
				imagePath: this._getSocialLinkImagePath(name)
			};
		});
	}

	_getSocialLinkImagePath(socialLinkName) {
		const baseImagePath = '/./images';

		switch (socialLinkName) {
			case 'Facebook':
				return `${baseImagePath}/navbar-fb.png`;
			case 'Twitter':
				return `${baseImagePath}/navbar-twitter.png`;
			case 'LinkedIn':
				return `${baseImagePath}/navbar-linkedin.png`;
		}
	}

	_getContactInformationObject({ email, phone, address }) {
		return {
			email,
			phone,
			address: this._getAddressDetailsObject(address)
		};
	}

	_getAddressDetailsObject({
		address_line_1: addressLine1,
		address_line_2: addressLine2,
		city_name: cityName,
		state_name: stateName,
		zip_code: zipCode
	}) {
		return {
			addressLine1,
			addressLine2,
			stateName,
			cityName,
			zipCode
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/components/home/home.service.js